import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import { LoginPage } from "../pages/LoginPage";
import { RequireAuth } from "../components/auth/RequireAuth";
import { RedirectIfAuth } from "../components/auth/RedirectIfAuth";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: (
      <RedirectIfAuth>
        <LoginPage initialMode="login" />
      </RedirectIfAuth>
    ),
  },
  {
    path: "/register",
    element: (
      <RedirectIfAuth>
        <LoginPage initialMode="register" />
      </RedirectIfAuth>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <RedirectIfAuth>
        <LoginPage initialMode="forgot-password" />
      </RedirectIfAuth>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <RedirectIfAuth>
        <LoginPage initialMode="reset-password" />
      </RedirectIfAuth>
    ),
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <Home />
      </RequireAuth>
    ),
  },
  {
    path: "/:section",
    element: (
      <RequireAuth>
        <Home />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
